import { ServiceBasicInfo } from './serviceitemsresponse';

export class ServiceItemDetailResponse {
  itemBasicInfo: ServiceBasicInfo;
  categoryName: string;
  iconData: string;
  iconMime: string;
  description: string;
  serviceFlag: boolean;
  customFields: (CustomFieldInfo)[] | null;
  serviceTargets: ServiceTargets;
}

export class CustomFieldInfo {
  displayName: string;
  targetFieldName: string;
  value: string;
  dataType: number;
  fieldType: number;
  valueType: number;
  dateFormat: string;
}

export class SlaContractInfo {
  priority: string;
  responseTime: number;
  restorationTime: number;
  fixTime: number;
  roundClockString: string;
}

export class ServiceTargets {
    incident: (SlaContractInfo)[];
    change: (SlaContractInfo)[];
    service: (SlaContractInfo)[];
    common: (SlaContractInfo)[];
}

